import React from 'react'
import Spinner from 'react-bootstrap/Spinner'

const Loader = () => {
    return (
        <div className="container-loader mb-3 mt-3">
            <div className="text-center">
                <Spinner animation="border" className="mb-2" variant="danger" />
                <div>Cargando . . .</div>
            </div>
        </div>
    )
}

export default Loader
